import baseConfig from './base';

const config = {
  appEnv: 'dist',
};

export default Object.freeze(Object.assign({}, baseConfig, config));



// WEBPACK FOOTER //
// ./config/dist.js